var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationAlertClose = function SvgNotificationAlertClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2D2C",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m1.519 18.754 17.26-17.26M18.779 18.754 1.519 1.494"
  })));
};
export { SvgNotificationAlertClose as ReactComponent };
export default __webpack_public_path__ + "images/Notification_Alert_Close.svg";